import { GetterTree } from 'vuex';
import { CommentModel } from '@/models/forumAPI/CommentModel';
import { CommentState } from './state';
import RootState from '@/store/root_state';
import { UnifiedCommentModel } from '@/models/UnifiedCommentModel';

const getters: GetterTree<CommentState, RootState> = {
  forumAPICommentById: (state, commentsGetters) => (commentId: string) => {
    const comment = state.comments[commentId];

    return comment
      ? new UnifiedCommentModel(new CommentModel(comment, commentsGetters))
      : undefined;
  },

  commentsByDiscussionId: (state, commentsGetters) => (discussionId: string) => {
    return Object.values(state.comments)
      .map((comment) => new CommentModel(comment, commentsGetters))
      .filter((comment) => comment.discussionId === discussionId)
      .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
      .map((comment) => new UnifiedCommentModel(comment));
  },

  forumCommentScoreUpdatingStatus: (state) => (commentId: number) =>
    state.isUpdatingForumCommentScore[commentId] || false,
};

export default getters;
